"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.destinationsReferenceList = exports.destinationsReferenceMap = exports.elasticsearchDestination = exports.plausibleDestination = exports.bentoDestination = exports.tagDestination = exports.mixpanel2Destination = exports.mixpanelDestination = exports.gcsDestination = exports.s3Destination = exports.dbtcloudDestination = exports.hubspotDestination = exports.amplitudeDestination = exports.webhookDestination = exports.googleAnalyticsDestination = exports.facebookDestination = exports.snowflakeDestination = exports.clickHouseDestination = exports.redshiftDestination = exports.bigQueryDestination = exports.mysqlDestination = exports.postgresDestination = void 0;
var postgres_1 = __importDefault(require("./postgres"));
exports.postgresDestination = postgres_1.default;
var mysql_1 = __importDefault(require("./mysql"));
exports.mysqlDestination = mysql_1.default;
var bigquery_1 = __importDefault(require("./bigquery"));
exports.bigQueryDestination = bigquery_1.default;
var redshift_1 = __importDefault(require("./redshift"));
exports.redshiftDestination = redshift_1.default;
var clickhouse_1 = __importDefault(require("./clickhouse"));
exports.clickHouseDestination = clickhouse_1.default;
var snowflake_1 = __importDefault(require("./snowflake"));
exports.snowflakeDestination = snowflake_1.default;
var facebook_1 = __importDefault(require("./facebook"));
exports.facebookDestination = facebook_1.default;
var googleAnalytics_1 = __importDefault(require("./googleAnalytics"));
exports.googleAnalyticsDestination = googleAnalytics_1.default;
var webhook_1 = __importDefault(require("./webhook"));
exports.webhookDestination = webhook_1.default;
var amplitude_1 = __importDefault(require("./amplitude"));
exports.amplitudeDestination = amplitude_1.default;
var hubspot_1 = __importDefault(require("./hubspot"));
exports.hubspotDestination = hubspot_1.default;
var dbtcloud_1 = __importDefault(require("./dbtcloud"));
exports.dbtcloudDestination = dbtcloud_1.default;
var s3_1 = __importDefault(require("./s3"));
exports.s3Destination = s3_1.default;
var googleCloudStorage_1 = __importDefault(require("./googleCloudStorage"));
exports.gcsDestination = googleCloudStorage_1.default;
var mixpanel_1 = __importDefault(require("./mixpanel"));
exports.mixpanelDestination = mixpanel_1.default;
var mixpanel2_1 = __importDefault(require("./mixpanel2"));
exports.mixpanel2Destination = mixpanel2_1.default;
var bento_1 = __importDefault(require("./bento"));
exports.bentoDestination = bento_1.default;
var plausible_1 = __importDefault(require("./plausible"));
exports.plausibleDestination = plausible_1.default;
var elasticsearch_1 = __importDefault(require("./elasticsearch"));
exports.elasticsearchDestination = elasticsearch_1.default;
var tag_1 = __importDefault(require("./tag"));
exports.tagDestination = tag_1.default;
exports.destinationsReferenceMap = {
    postgres: postgres_1.default,
    mysql: mysql_1.default,
    bigquery: bigquery_1.default,
    redshift: redshift_1.default,
    clickhouse: clickhouse_1.default,
    snowflake: snowflake_1.default,
    facebook: facebook_1.default,
    google_analytics: googleAnalytics_1.default,
    webhook: webhook_1.default,
    amplitude: amplitude_1.default,
    hubspot: hubspot_1.default,
    dbtcloud: dbtcloud_1.default,
    s3: s3_1.default,
    gcs: googleCloudStorage_1.default,
    mixpanel: mixpanel_1.default,
    mixpanel2: mixpanel2_1.default,
    tag: tag_1.default,
    bento: bento_1.default,
    plausible: plausible_1.default,
    elasticsearch: elasticsearch_1.default,
};
exports.destinationsReferenceList = Object.values(exports.destinationsReferenceMap);
